module.exports = __webpack_public_path__ + "img/Size=24, Style=solid.95463ea1.svg";